import { CombinedSessionItem } from './CombinedSessionItem';
import { SessionTokenStorage } from './SessionTokenStorage';
export class CombinedTokenStorage extends SessionTokenStorage {
  createStorageItem() {
    return new CombinedSessionItem();
  }
}
//# sourceMappingURL=CombinedTokenStorage.js.map